import anime from 'animejs';
import Medusa from '@adoratorio/medusa';
import engine from '@/scripts/engine';

function clamp(v, min = 0, max = 1) {
  return Math.min(max, Math.max(min, v));
}

function invlerp(a, b, v) {
  return clamp((v - a) / (b - a));
}

function animation(el) {
  return anime({
    targets: el.children[0],
    translateY: {
      value: ['0', '-20%'],
      duration: 100,
      easing: 'linear',
    },
    // easing: 'linear',
    duration: 100,
    autoplay: false,
  });
}

export default {
  id: 'simpleParallax',
  nodes: [],
  container: document.getElementById('app'),
  threshold: Medusa.THRESHOLD.BEARLY,
  offsets: '0px 0px 0px 0px',
  emitGlobal: false,
  callback: ({ isIntersecting, target }) => {
    if (isIntersecting) {
      const { height } = target.getBoundingClientRect();

      const scroll = offsetTop => invlerp(-window.innerHeight, height, -offsetTop);

      const parallax = animation(target);

      engine.add(() => {
        parallax.seek(scroll(target.getBoundingClientRect().top) * 100);
      }, target);
    } else {
      engine.remove(target);
    }
  },
  mode: Medusa.MODE.DEFAULT,
};
